import React, { useEffect, useState } from "react";
import TableViewSystemForm from "./TableViewForm";
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/tableViewActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

const TableViewSystemEdit = props => {
    const { classes, tableView, onFetchTableViewInit, onFetchTableView, onEditTableView, activeCustomerID, translations, permissions } = props;
    const [data, setData] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await onFetchTableView({ ActiveCustomerID: activeCustomerID, TableViewID: parseURL(window.location.href).TableViewID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchTableViewInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data["TableViewID"] = tableView.TableViewID;
        let result = await onEditTableView({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack()
        }
    };
    let initialValues = {
        Name: tableView?.Name || "",
        QueryType: tableView?.QueryType || "",
        Parameters: tableView?.Parameters || ""
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            QueryType: Yup.string().required("Required"),
            Parameters: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_table_view"] || "Edit table view",
        ButtonSubmit: hasPermission(permissions, "table_view_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <img alt="App logo loading" className={classes.logo} src={process.env.PUBLIC_URL + '/assets/images/app-logo-loading.gif'} />
            </Dialog>
            {!data ?
                <TableViewSystemForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    translations={translations}
                />
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        tableView: state?.system?.tableView?.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchTableViewInit: params => dispatch(actions.loadTableViewInit(params)),
        onFetchTableView: params => dispatch(actions.loadTableView(params)),
        onEditTableView: params => dispatch(actions.editTableView(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TableViewSystemEdit));
